import { createFileRoute, Outlet } from '@tanstack/react-router'
import { chequeQueryOptions } from '../../../../features/cheques/queries'

export const Route = createFileRoute('/_app/cheques/$chequeId')({
  staticData: { crumb: 'cheque' },
  loader: ({ context, params }) => context.queryClient.ensureQueryData(chequeQueryOptions(params.chequeId)),
  component: Outlet,
})
